export const apiUrl = process.env.REACT_APP_DRACOR_API;
export const sparqlUrl = process.env.REACT_APP_SPARQL_URL;
export const shortenerUrl = process.env.REACT_APP_SHORTENER_URL;
export const ezlinavisUrl = process.env.REACT_APP_EZLINAVIS_URL;
